/* Selected Wallpapers — levertijd-cart (extern gemaakt 14-09-2026, was inline; laadt 1x per pagina, cache) */
(function(){
  if (window.__swLtCartAsset) return; window.__swLtCartAsset = 1;
function swCfgAll(name){ return Array.prototype.slice.call(document.querySelectorAll('script[data-sw-cfg="' + name + '"]')); }
function swCfgParse(el){ try { return JSON.parse(el.textContent || '{}'); } catch(e){ return {}; } }
function swVariants(sectionId, fallback){ var el = sectionId ? document.getElementById('VariantData-' + sectionId) : null; if (el) { try { var v = JSON.parse(el.textContent || '[]'); if (Array.isArray(v)) return v; } catch(e){} } return Array.isArray(fallback) ? fallback : []; }
function swReady(fn){ if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  function init(cfg){
/* LEVERTIJD-OPTION-B (recalculate on view + update line-item property before checkout) */
(function(){
  var LANG = cfg.lang;
  LANG = (LANG || 'en').toLowerCase();
  if (LANG.length > 2) LANG = LANG.slice(0,2);

  

  var ACTIVE_COUNTRY = cfg.country || '';
  ACTIVE_COUNTRY = (ACTIVE_COUNTRY || '').toString().toUpperCase();
var DAYNAMES = {
    nl: ['maandag','dinsdag','woensdag','donderdag','vrijdag','zaterdag','zondag'],
    de: ['Montag','Dienstag','Mittwoch','Donnerstag','Freitag','Samstag','Sonntag'],
    en: ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'],
    fr: ['lundi','mardi','mercredi','jeudi','vendredi','samedi','dimanche'],
    it: ['lunedì','martedì','mercoledì','giovedì','venerdì','sabato','domenica'], es: ['lunes','martes','miércoles','jueves','viernes','sábado','domingo']
  };
  var MONTHNAMES = {
    nl: ['januari','februari','maart','april','mei','juni','juli','augustus','september','oktober','november','december'],
    de: ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'],
    en: ['January','February','March','April','May','June','July','August','September','October','November','December'],
    fr: ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'],
    it: ['gennaio','febbraio','marzo','aprile','maggio','giugno','luglio','agosto','settembre','ottobre','novembre','dicembre'], es: ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre']
  };

  function L(){ return (DAYNAMES[LANG] ? LANG : 'en'); }
  function isWorkdayMonFri(d){ var wd=d.getDay(); return wd>=1 && wd<=5; }
  function isDeliveryDayMonSat(d){ var wd=d.getDay(); return wd>=1 && wd<=6; }
  function addDays(d, n){ var x=new Date(d.getTime()); x.setDate(x.getDate()+n); return x; }

  function nextWorkday(d){
    var x=new Date(d.getTime());
    for(var i=0;i<14;i++){ if(isWorkdayMonFri(x)) return x; x=addDays(x,1); }
    return x;
  }

  function addBusinessDaysMonFri(start, count){
    var x=new Date(start.getTime());
    var got=0;
    for(var i=0;i<120;i++){ x=addDays(x,1); if(isWorkdayMonFri(x)){ got++; if(got>=count) break; } }
    return x;
  }

  function addDeliveryDaysMonSat(start, count){
    var x=new Date(start.getTime());
    var got=0;
    if(count<=0) return x;
    for(var i=0;i<365;i++){ x=addDays(x,1); if(isDeliveryDayMonSat(x)){ got++; if(got>=count) break; } }
    return x;
  }

  function formatDate(d){
    var lang=L();
    var dn=DAYNAMES[lang][(d.getDay()+6)%7];
    var day=d.getDate();
    var mn=MONTHNAMES[lang][d.getMonth()];
    return dn + ' ' + day + ' ' + mn;
  }

  function computeDeliveryDateStr(shipDays, cutoffH){
    shipDays = parseInt(shipDays, 10) || 0;
    if(shipDays<=0) return '';

    var now = new Date();
    cutoffH = parseInt(cutoffH, 10);
    if(isNaN(cutoffH) || !isFinite(cutoffH)) cutoffH = 15;
    var effective = new Date(now.getTime());

    var afterCutoff = (effective.getHours() > cutoffH) || (effective.getHours() === cutoffH && effective.getMinutes() >= 0);
    var wd = effective.getDay();
    var weekend = (wd === 0 || wd === 6);
    if(weekend || afterCutoff){
      effective = addDays(effective, 1);
      effective = nextWorkday(effective);
    } else {
      effective = nextWorkday(effective);
    }

    var dispatch = addBusinessDaysMonFri(effective, 1);
    var delivery = addDeliveryDaysMonSat(dispatch, shipDays);
    return formatDate(delivery);
  }

  function findDeliveryKey(props){
    if(props){
      if(props._lt_cart_key) return props._lt_cart_key;
      if(props['Levertijd']) return 'Levertijd';
      if(props['Delivery time']) return 'Delivery time';
      if(props['Lieferzeit']) return 'Lieferzeit';
      if(props['Délai de livraison']) return 'Délai de livraison';
      if(props['Tempi di consegna']) return 'Tempi di consegna';
      if(props['Plazo de entrega']) return 'Plazo de entrega';
    }
    // Fallback: determine key from page language
    var lang = document.documentElement.lang || '';
    lang = lang.toLowerCase().slice(0,2);
    if(lang === 'nl') return 'Levertijd';
    if(lang === 'de') return 'Lieferzeit';
    if(lang === 'fr') return 'Délai de livraison';
    if(lang === 'it') return 'Tempi di consegna';
    if(lang === 'es') return 'Plazo de entrega';
    return 'Delivery time';
  }


  
  // SWP: Server-truth delivery time sync (no reliance on _lt_* meta in cart properties).
  // We render the levertijd section for the current locale/market and read data-cart-* attributes.
  var __swpLtCache = {};
  function isSampleLine(item){
    try{
      var p = item && item.properties ? item.properties : {};
      var v = p && (p._is_sample || p['_is_sample']);
      if(v && (v === '1' || v === 1 || v === true || v === 'true')) return true;

      var parts = [
        item && item.title ? item.title : '',
        item && item.product_title ? item.product_title : '',
        item && item.variant_title ? item.variant_title : ''
      ];
      var t = parts.join(' ').toLowerCase();
      return t.indexOf('sample') !== -1 || t.indexOf('muster') !== -1;
    } catch(e) { return false; }
  }

  function cloneProps(props){
    var out = {};
    if(!props) return out;
    for (var k in props){
      if(Object.prototype.hasOwnProperty.call(props, k)) out[k] = props[k];
    }
    return out;
  }

  async function fetchDeliveryFromProduct(item){
    try{
      if(!item || !item.url) return null;

      // IMPORTANT:
      // Shopify's reliable Section Rendering API uses `?sections=...` (JSON response),
      // while the legacy section_id endpoint is inconsistent on localized routes like /en-us/ and can 404.
      // So we fetch 1 request per item with multiple candidate sections and then parse the HTML.
      var baseUrl = item.url.toString().split('?')[0];
      var vid = item.variant_id || item.id;

      // Candidate sections that may contain the levertijd markup (keep list short for performance).
      // Put the most likely first.
      var sectionIds = [
        'levertijd-live',
        'levertijd',
        'main-product',
        'product-template',
        'main',
        'product'
      ];

      // Preferred: lightweight view endpoint (stable across markets/languages).
      // Requires: templates/product.levertijd.liquid (URL param: ?view=levertijd)
      var combinedHtml = '';
      try{
        var viewUrl = baseUrl + '?variant=' + encodeURIComponent(vid) + '&view=levertijd&_=' + Date.now();
        var rView = await fetch(viewUrl, { credentials:'same-origin', headers:{'Accept':'text/html'} });
        if(rView && rView.ok) combinedHtml = await rView.text();
      }catch(eView){}

      if(!combinedHtml){
        // Fallback: Section Rendering API (JSON). This depends on the section IDs present on the product template.
        // Build sections param (do NOT URL-encode the commas; encode each id instead).
        var sectionsParam = sectionIds.map(function(s){ return encodeURIComponent(String(s)); }).join(',');
        var u = baseUrl + '?variant=' + encodeURIComponent(vid) + '&sections=' + sectionsParam + '&_=' + Date.now();
        var r = await fetch(u, { credentials:'same-origin', headers:{ 'Accept':'application/json' }});
        if(r && r.ok){
          var data = await r.json();
          var html = '';
          for(var k in data){ if(data[k]) html += data[k]; }
          combinedHtml = html;
        }
      }

      if(!combinedHtml) return null;
      var doc = new DOMParser().parseFromString(combinedHtml, 'text/html');

      // Identify which property key to update (preserve language if already present)
      var key = findDeliveryKey(item.properties || {});

      // Strategy A: explicit data-* attributes (preferred)
      var value = null;
      var swMax = null;   // bestellen boven voorraad: maximaal te bestellen (data-max), of null = geen grens
      var root = doc.querySelector('[data-levertijd],[data-delivery-time],[data-levertijd-root],[data-delivery-time-root]');
      if(root){
        // Use data-cart-key from rendered section as authoritative key (matches server-side locale)
        var serverKey = root.getAttribute('data-cart-key');
        if(serverKey) key = serverKey.trim();
        var isSample = isSampleLine(item);
        if(isSample){
          value = root.getAttribute('data-cart-value-sample') || root.getAttribute('data-cart-sample') || null;
        } else {
          value = root.getAttribute('data-cart-value-normal') || root.getAttribute('data-cart-normal') || null;
          // Bestellen boven voorraad (Kevin 08-10-2026): regel boven de voorraad = de hele regel op de latere levering
          try {
            var bbv = JSON.parse(root.getAttribute('data-bbv') || 'null');
            var q = parseInt(item.quantity, 10) || 0;
            var maxAttr = parseInt(root.getAttribute('data-max') || '', 10);
            if (isFinite(maxAttr) && maxAttr > 0){ swMax = maxAttr; if (q > swMax) q = swMax; }
            if (bbv && typeof bbv.voorraad === 'number' && q > bbv.voorraad){
              var keuze = null, st = bbv.stappen || [];
              for (var si = 0; si < st.length; si++){ if (q <= st[si].tot){ keuze = st[si]; break; } }
              if (!keuze) keuze = bbv.standaard || (st.length ? st[st.length - 1] : null);
              if (keuze && keuze.datum) value = keuze.datum;
            }
          } catch(eBbv){ if (window.console) console.warn('levertijd boven voorraad', eBbv); }
        }
        value = (value || '').toString().trim();
      }

      // Strategy B: parse visible text from known elements
      if(!value){
        var txtEl = doc.querySelector('.deliverytime, .levertijd, .pr_vr, [data-delivery-time], [data-levertijd-value]');
        var txt = txtEl ? (txtEl.textContent || '') : ((doc.body && doc.body.textContent) ? doc.body.textContent : '');
        txt = (txt || '').toString().replace(/\s+/g,' ').trim();

        // Extract label:value in multiple languages
        var re1 = /(?:Delivery time|Levertijd|Lieferzeit|Délai de livraison|Tempi di consegna|Plazo de entrega)\s*:\s*([^<>]+)/i;
        var m1 = txt.match(re1);
        var raw = (m1 && m1[1]) ? m1[1] : txt;

        raw = (raw || '').toString().trim();

        // If the text contains a sentence, try to keep only the final date segment
        // Examples:
        // "Ordered today, delivered on Thursday 15 January!"
        // "Vandaag besteld, geleverd op donderdag 15 januari!"
        var m2 = raw.match(/delivered on\s*([A-Za-zÀ-ÿ]+\s+\d{1,2}\s+[A-Za-zÀ-ÿ]+)/i);
        var m3 = raw.match(/geleverd op\s*([A-Za-zÀ-ÿ]+\s+\d{1,2}\s+[A-Za-zÀ-ÿ]+)/i);
        if(m2 && m2[1]) value = m2[1].trim();
        else if(m3 && m3[1]) value = m3[1].trim();
        else {
          // Fallback: trim trailing punctuation
          value = raw.replace(/[!.,;:]+$/,'').trim();
        }
      }

      if(!value) return null;

      var out = { key: key, value: value };
      if (swMax != null) out.max = swMax;
      __swpLtCache[u] = out;
      return out;

    }catch(e){
      return null;
    }
  }


function parseCsv(v){
    v = (v || '').toString().toUpperCase().replace(/\s+/g,'').trim();
    if(!v) return [];
    return v.split(',').map(function(x){ return x.trim(); }).filter(Boolean);
  }

  function addDaysForCountry(props, country){
    country = (country || '').toString().toUpperCase().trim();
    if(!country) return 0;
    var p6 = parseCsv(props._lt_plus6); if(p6.indexOf(country)!==-1) return 6;
    var p5 = parseCsv(props._lt_plus5); if(p5.indexOf(country)!==-1) return 5;
    var p4 = parseCsv(props._lt_plus4); if(p4.indexOf(country)!==-1) return 4;
    var p3 = parseCsv(props._lt_plus3); if(p3.indexOf(country)!==-1) return 3;
    var p2 = parseCsv(props._lt_plus2); if(p2.indexOf(country)!==-1) return 2;
    var p1 = parseCsv(props._lt_plus1); if(p1.indexOf(country)!==-1) return 1;
    return 0;
  }

  function effectiveShipDays(props){
    var base = parseInt(props._lt_base_nl_days, 10);
    if(!isNaN(base) && isFinite(base)){
      return base + addDaysForCountry(props, ACTIVE_COUNTRY);
    }
    // If meta is missing, fallback to existing visible property (cannot recompute)
    return null;
  }

  function effectiveCutoffHour(props){
    var h = parseInt(props._lt_cutoff_hour, 10);
    return (isNaN(h) || !isFinite(h)) ? 15 : h;
  }

  async function fetchCart(){
    var cartUrl = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    var r = await fetch(cartUrl + '.js', { credentials: 'same-origin' });
    if(!r.ok) throw new Error('cart.js failed');
    return await r.json();
  }

  // SW 10-09-2026: op regelSLEUTEL schrijven met de verse stand van die regel. De oude versie schreef op regelnummer
  // met het aantal uit een eerdere momentopname; verdween er intussen een regel erboven (klant haalt rollen weg, of
  // sanitizeCartForActiveMarket ruimt een niet-leverbaar product op), dan kreeg de volgende regel dat aantal en die
  // levertijd (SW24062: staal x5, SW24156: staal x6). Regel weg = niets schrijven; een staal raken we nooit aan.
  async function changeLine(key, dKey, dValue){
    var vers = await fetchCart();
    var regel = null;
    for (var k = 0; k < ((vers && vers.items) || []).length; k++) { if (vers.items[k].key === key) { regel = vers.items[k]; break; } }
    if(!regel || isSampleLine(regel)) return null;
    var properties = cloneProps(regel.properties || {});
    ['Levertijd','Delivery time','Lieferzeit','Délai de livraison','Tempi di consegna','Plazo de entrega'].forEach(function(k){ if(k !== dKey && properties[k] != null) delete properties[k]; });
    properties[dKey] = dValue;
    var payload = { id: key, quantity: regel.quantity, properties: properties };
    var r = await fetch(((window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });
    if(!r.ok) throw new Error('change.js failed');
    return await r.json();
  }

  // Bestellen boven voorraad (Kevin 08-10-2026: "nooit gokken"): meer dan voorraad + bekende leveringen kan niet, ook niet
  // via de winkelwagen. Aantal en levertijd van de regel in één keer terug naar het maximum.
  async function zetAantal(key, aantal, dKey, dValue){
    var vers = await fetchCart();
    var regel = null;
    for (var k = 0; k < ((vers && vers.items) || []).length; k++) { if (vers.items[k].key === key) { regel = vers.items[k]; break; } }
    if(!regel || isSampleLine(regel)) return null;
    var properties = cloneProps(regel.properties || {});
    ['Levertijd','Delivery time','Lieferzeit','Délai de livraison','Tempi di consegna','Plazo de entrega'].forEach(function(k){ if(k !== dKey && properties[k] != null) delete properties[k]; });
    if (dKey && dValue) properties[dKey] = dValue;
    var r = await fetch(((window.routes && window.routes.cart_change_url) ? window.routes.cart_change_url : '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: aantal, properties: properties })
    });
    if(!r.ok) throw new Error('change.js (maximum) failed');
    return await r.json();
  }

  var SW_MAX_TEKST = {
    nl: '{t}: maximaal {n} leverbaar, het aantal is aangepast.',
    en: '{t}: only {n} available, the quantity has been adjusted.',
    de: '{t}: höchstens {n} lieferbar, die Menge wurde angepasst.',
    fr: '{t} : {n} maximum disponibles, la quantité a été ajustée.',
    it: '{t}: massimo {n} disponibili, la quantità è stata modificata.',
    es: '{t}: máximo {n} disponibles, se ha ajustado la cantidad.'
  };
  function swMaxMelding(lijst){
    try {
      var sjabloon = SW_MAX_TEKST[LANG] || SW_MAX_TEKST.en;
      var tekst = lijst.map(function(x){ return sjabloon.replace('{t}', x.titel).replace('{n}', x.max); }).join(' ');
      var el = document.getElementById('sw-max-melding');
      if (!el) {
        el = document.createElement('div');
        el.id = 'sw-max-melding';
        el.setAttribute('role', 'status');
        el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;max-width:min(92vw,460px);'
          + 'background:#fff;color:#232220;border:1px solid #e2dccf;box-shadow:0 6px 24px rgba(0,0,0,.12);padding:12px 16px;'
          + 'font:400 13px/1.5 Poppins,sans-serif;';
        document.body.appendChild(el);
      }
      el.textContent = tekst;
      clearTimeout(el.__swTimer);
      el.__swTimer = setTimeout(function(){ if (el && el.parentNode) el.parentNode.removeChild(el); }, 8000);
    } catch(e){ if (window.console) console.warn('levertijd max melding', e); }
  }

  function updateDOMLineItem(lineIndex, key, value){
    // Prefer the dedicated element if present (so labels can be localized independent of stored cart property keys)
    var label = null;
    try {
      var probe = document.querySelector('#CartDrawer-Item-' + (lineIndex+1) + ' .js-delivery-time') ||
                  document.querySelector('#CartItem-' + (lineIndex+1) + ' .js-delivery-time');
      if (probe && probe.dataset && probe.dataset.deliveryLabel) label = probe.dataset.deliveryLabel;
    } catch(e) {}

    if(!label){
      try{
        var lang = (typeof L === 'function') ? L() : '';
        if(lang === 'nl') label = 'Levertijd';
        else if(lang === 'de') label = 'Lieferzeit';
        else if(lang === 'fr') label = 'Délai de livraison';
        else if(lang === 'it') label = 'Tempi di consegna';
        else if(lang === 'es') label = 'Plazo de entrega';
        else label = 'Delivery time';
      } catch(e){
        label = 'Delivery time';
      }
    }

    // Update dedicated delivery-time nodes first
    try {
      var dtSel = [
        '#CartItem-' + (lineIndex+1) + ' .js-delivery-time',
        '#CartDrawer-Item-' + (lineIndex+1) + ' .js-delivery-time'
      ];
      for (var ds=0; ds<dtSel.length; ds++){
        var dtEls = document.querySelectorAll(dtSel[ds]);
        for (var di=0; di<dtEls.length; di++){
          dtEls[di].style.display = '';
          dtEls[di].innerHTML = label + ':&nbsp; ' + value;
        }
      }
    } catch(e) {}

    // Backward compatibility: update any legacy nodes that still print the property key
    var knownKeys = [key, 'Levertijd', 'Delivery time', 'Lieferzeit', 'Délai de livraison', 'Tempi di consegna', 'Plazo de entrega'];
    knownKeys = knownKeys.filter(function(v, i, a){ return v && a.indexOf(v) === i; });

    var selectors = [
      '#CartItem-' + (lineIndex+1) + ' .product-option',
      '#CartDrawer-Item-' + (lineIndex+1) + ' .pr_vr'
    ];

    for(var s=0;s<selectors.length;s++) {
      var els = document.querySelectorAll(selectors[s]);
      for(var i=0;i<els.length;i++) {
        var el = els[i];
        var t = (el.textContent || '').trim();
        if(!t) continue;

        var matched = null;
        for(var k=0;k<knownKeys.length;k++){
          var kk = knownKeys[k];
          if(t.toLowerCase().indexOf((kk + ':').toLowerCase()) === 0){ matched = kk; break; }
        }

        if(matched !== null){
          el.innerHTML = label + ':&nbsp; ' + value;
        }
      }
    }
  }

  async function recalcAndPaint(){
    try {
      var cart = await fetchCart();
      if(!cart || !cart.items) return;

      // Persist guard to avoid loops
      window.__SWP_LT_LAST = window.__SWP_LT_LAST || {};
      var geclampt = [], viaRefresh = false;

      for(var i=0;i<cart.items.length;i++) {
        var it = cart.items[i];
        if(isSampleLine(it)) continue;

        var props = it.properties || {};

        var d = await fetchDeliveryFromProduct(it);
        if(!d) continue;

        if (d.max != null && (parseInt(it.quantity, 10) || 0) > d.max) {
          try {
            // via de eigen drawer-functie (blijft open, rendert zelf en meldt cart-update -> hier opnieuw, dan binnen het maximum)
            var swLijst = document.querySelector('cart-drawer-items');
            if (swLijst && typeof swLijst.updateQuantity === 'function') swLijst.updateQuantity(i + 1, d.max);
            else { await zetAantal(it.key, d.max, d.key, d.value); viaRefresh = true; }
            geclampt.push({ titel: it.product_title || it.title || '', max: d.max });
          } catch(eMax){ if (window.console) console.warn('levertijd maximum', eMax); }
          continue;
        }

        // Update UI (drawer + cart page)
        updateDOMLineItem(i, d.key, d.value);

        // Persist to cart so /cart.js reflects the new delivery time (optional but desired).
        // Only update if it actually differs AND we have not already persisted this exact value.
        var sig = String(d.key) + '|' + String(d.value);
        if(window.__SWP_LT_LAST[it.key] === sig) continue;

        var cur = (props && props[d.key] != null) ? String(props[d.key]).trim() : '';
        if(cur !== String(d.value).trim()){
          try{
            await changeLine(it.key, d.key, d.value);
            window.__SWP_LT_LAST[it.key] = sig;
          }catch(e){}
        } else {
          window.__SWP_LT_LAST[it.key] = sig;
        }
      }
      if (geclampt.length) {
        swMaxMelding(geclampt);
        if (viaRefresh && window.__swpRefreshDrawer) await window.__swpRefreshDrawer();
      }
    } catch(e) {}
  }

  async function updateBeforeCheckout(formEl, btnEl){
    var geclampt = [];
    try {
      if(btnEl) {
        btnEl.setAttribute('aria-busy', 'true');
        if('disabled' in btnEl) btnEl.disabled = true;
      }
      var cart = await fetchCart();
      if(cart && cart.items && cart.items.length) {
        for(var i=0;i<cart.items.length;i++) {
          var it = cart.items[i];
          if(isSampleLine(it)) continue;

          var props = it.properties || {};

          var d = await fetchDeliveryFromProduct(it);
          if(!d) continue;

          if (d.max != null && (parseInt(it.quantity, 10) || 0) > d.max) {
            await zetAantal(it.key, d.max, d.key, d.value);
            geclampt.push({ titel: it.product_title || it.title || '', max: d.max });
            continue;
          }

          var cur = (props && props[d.key] != null) ? String(props[d.key]).trim() : '';
          if(cur === String(d.value).trim()) continue;

          await changeLine(it.key, d.key, d.value);
        }
      }
      } catch(e) {
      // If update fails, still continue to checkout
    } finally {
      try {
        if (btnEl) {
          btnEl.removeAttribute('aria-busy');
          if ('disabled' in btnEl) btnEl.disabled = false;
        }

        // aantal teruggezet naar het maximum: niet afrekenen, eerst laten zien
        if (geclampt.length) {
          swMaxMelding(geclampt);
          if (window.__swpRefreshDrawer) window.__swpRefreshDrawer();
          return;
        }

        if (formEl) {
          if (typeof formEl.requestSubmit === 'function') {
            formEl.requestSubmit(btnEl || undefined);
            return;
          }

          if (btnEl && btnEl.name) {
            var hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = btnEl.name;
            hidden.value = btnEl.value || '';
            formEl.appendChild(hidden);
          }

          formEl.submit();
        }
      } catch(submitErr) {
        if (formEl) formEl.submit();
      }
    }
  }

  function bindCheckout(){
    // SWP FIX (12-06-2026): capture-phase submit-interceptie i.p.v. losse
    // knop-IDs. Dekt ALLE submit-paden naar checkout (named buttons,
    // enter-toets, andere knoppen met name=checkout).
    document.addEventListener('submit', function(ev){
      try {
        var form = ev.target;
        if(!form || form.__swpLtSynced) return;
        var action = (form.getAttribute('action') || '').toString();
        if(action.indexOf('/cart') === -1) return;
        var submitter = ev.submitter || null;
        var goesToCheckout = false;
        if (submitter && (submitter.name === 'checkout' || submitter.id === 'cartCheckout' || submitter.id === 'CartDrawer-Checkout')) {
          goesToCheckout = true;
        } else if (!submitter) {
          goesToCheckout = !!form.querySelector('button[name="checkout"],input[name="checkout"]');
        }
        if(!goesToCheckout) return;
        ev.preventDefault();
        ev.stopPropagation();
        form.__swpLtSynced = true;
        setTimeout(function(){ form.__swpLtSynced = false; }, 8000);
        updateBeforeCheckout(form, submitter);
      } catch(e) {}
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){ bindCheckout(); recalcAndPaint(); });
  } else {
    bindCheckout(); recalcAndPaint();
  }

  // Dawn-drawer (Kevin 08-10-2026): aantal gewijzigd of iets toegevoegd -> opnieuw rekenen en zo nodig terug naar het maximum.
  // De drawer stuurt geen cart:refresh/-updated, wel PUB_SUB_EVENTS.cartUpdate.
  function swAbonneer(){
    try {
      if (window.__swLtAbonnee) return;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        window.__swLtAbonnee = true;
        var swLtTimer = null;
        subscribe(PUB_SUB_EVENTS.cartUpdate, function(){ clearTimeout(swLtTimer); swLtTimer = setTimeout(recalcAndPaint, 350); });
      }
    } catch(eSub){ if (window.console) console.warn('levertijd cart-update', eSub); }
  }
  swAbonneer();
  window.addEventListener('load', swAbonneer);
  document.addEventListener('cart:refresh', recalcAndPaint, true);
  document.addEventListener('cart:updated', recalcAndPaint, true);
  document.addEventListener('cart:rendered', recalcAndPaint, true);
})();


/* SWP MARKET SYNC (v2)
   Goal:
   - After a Market / country / currency / language switch, ensure the cart is valid for the ACTIVE context.
   - Remove items that are not accessible in the active locale (product JSON 404) or not purchasable (variant missing/unavailable/price==0).
   Notes:
   - We do NOT try to "convert" prices ourselves. Shopify returns presentment prices in /cart.js for the active market.
   - If amounts stay identical between EUR and USD, that's a Shopify Markets pricing configuration (fixed price lists / 1:1) issue.
*/
(function() {
  if (window.__SWP_MARKET_SYNC_V2) return;
  window.__SWP_MARKET_SYNC_V2 = true;

  var CTX = {
    country: (cfg.country || ''),
    language: (cfg.language || ''),
    currency: (cfg.currency || '')
  };

  function rootUrl() {
    try { return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/'; } catch(e) { return '/'; }
  }

  function ctxKey(c) { return [c.country||'', c.language||'', c.currency||''].join('|'); }

  function sleep(ms){ return new Promise(function(r){ setTimeout(r, ms); }); }

  async function fetchJSON(url, opts) {
    var res = await fetch(url, Object.assign({
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    }, (opts||{})));
    if (!res.ok) {
      var err = new Error('HTTP ' + res.status + ' for ' + url);
      err.status = res.status;
      throw err;
    }
    return await res.json();
  }

  async function fetchProductJSON(handle) {
    // Important: use rootUrl() to stay locale-aware (/en-us/ etc.)
    var url = rootUrl() + 'products/' + encodeURIComponent(handle) + '.js';
    return await fetchJSON(url);
  }

  async function removeLineByKey(key) {
    try {
      await fetchJSON(rootUrl() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      return true;
    } catch(e) { return false; }
  }

    function updateCartCountFromCart(cart) {
    try {
      var count = (cart && typeof cart.item_count === 'number') ? cart.item_count : null;
      if (count === null) return;

      var nodes = [];
      // Common patterns across themes
      nodes = nodes.concat(Array.prototype.slice.call(document.querySelectorAll('#cart-icon-bubble .cart-count-bubble span[aria-hidden]')));
      nodes = nodes.concat(Array.prototype.slice.call(document.querySelectorAll('#cart-icon-bubble .cart-count-bubble')));
      nodes = nodes.concat(Array.prototype.slice.call(document.querySelectorAll('.cart-count-bubble span[aria-hidden]')));
      nodes = nodes.concat(Array.prototype.slice.call(document.querySelectorAll('.cart-count-bubble')));
      nodes = nodes.concat(Array.prototype.slice.call(document.querySelectorAll('[data-cart-count]')));
      nodes = nodes.concat(Array.prototype.slice.call(document.querySelectorAll('#CartCount')));
      nodes = nodes.concat(Array.prototype.slice.call(document.querySelectorAll('#CartCount span')));

      // De-dup
      nodes = nodes.filter(function(n, idx){ return n && nodes.indexOf(n) === idx; });

      nodes.forEach(function(node) {
        // If node is a wrapper, try to find the inner span; else set directly
        var target = node;
        var inner = node.querySelector && node.querySelector('span[aria-hidden]');
        if (inner) target = inner;

        if (target && target.nodeType === 1) {
          // Update text
          target.textContent = String(count);
        }

        // Handle data attribute
        try { node.setAttribute && node.setAttribute('data-cart-count', String(count)); } catch(e) {}
      });

      // Hide/show bubbles when count is zero
      var bubbles = document.querySelectorAll('.cart-count-bubble');
      bubbles.forEach(function(b){
        try {
          if (count <= 0) b.classList.add('hidden');
          else b.classList.remove('hidden');
        } catch(e) {}
      });
    } catch(e) {}
  }

  async function refreshDrawerSections() {
    // Section render refresh (preferred)
    try {
      var data = await fetchJSON(rootUrl() + '?sections=cart-drawer,cart-icon-bubble');

      function replaceSectionHTML(sectionHTML, selector) {
        var doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
        var newEl = doc.querySelector(selector);
        var curEl = document.querySelector(selector);
        if (newEl && curEl) { curEl.replaceWith(newEl); return true; }
        return false;
      }

      if (data && data['cart-drawer']) {
        var ok = replaceSectionHTML(data['cart-drawer'], '#CartDrawer');
        if (!ok) replaceSectionHTML(data['cart-drawer'], 'cart-drawer');
      }
      if (data && data['cart-icon-bubble']) {
        replaceSectionHTML(data['cart-icon-bubble'], '#cart-icon-bubble');
      }

      try { document.dispatchEvent(new CustomEvent('cart:rendered', { bubbles: true })); } catch(e) {}
      return true;
    } catch(e) {
      return false;
    }
  }

  window.__swpRefreshDrawer = refreshDrawerSections;

  async function sanitizeCartForActiveMarket() {
    var cart = await fetchJSON(rootUrl() + 'cart.js');
    if (!cart || !cart.items || !cart.items.length) return { removed: 0, checked: 0, reason: 'empty' };

    var removed = 0, checked = 0, stalenWeg = 0;

    // Sequential to avoid rate limits and keep cart state stable.
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (!item) continue;
      checked++;

      var shouldRemove = false;

      // Kevin 15-10-2026: geen stalen naar het VK. Wie met stalen in het mandje naar het VK wisselt, raakt ze kwijt.
      if (window.swStaalUK && swIsStaalRegel(item)) {
        var okStaal = await removeLineByKey(item.key);
        if (okStaal) { removed++; stalenWeg++; }
        await sleep(80);
        continue;
      }

      // 1) If product is not accessible in this locale/market, product JSON will typically 404.
      // This catches your "Botanic is 404 in /en-us/" case reliably.
      var product = null;
      try {
        product = await fetchProductJSON(item.handle);
      } catch(e) {
        shouldRemove = true;
      }

      // 2) If product exists, verify variant exists and is purchasable.
      if (!shouldRemove && product && product.variants && product.variants.length) {
        var variant = null;
        for (var v = 0; v < product.variants.length; v++) {
          if (String(product.variants[v].id) === String(item.variant_id)) { variant = product.variants[v]; break; }
        }
        if (!variant) {
          shouldRemove = true;
        } else {
          if (variant.available === false) shouldRemove = true;
          // Price-on-request often ends up as price 0 in storefront context. Remove to avoid "$0" confusion.
          if (typeof variant.price === 'number' && variant.price === 0) shouldRemove = true;
        }
      }

      if (shouldRemove) {
        var ok = await removeLineByKey(item.key);
        if (ok) removed++;
        await sleep(80);
      }
    }

    // Kevin 15-10-2026: de levertijd-sync schrijft soms tegelijk een regel bij en zet dan het mandje van een
    // fractie eerder terug (staal weer terug). Daarom nacontrole: tot 3x kijken en opnieuw verwijderen.
    if (window.swStaalUK) {
      for (var poging = 0; poging < 3; poging++) {
        await sleep(700);
        var nu = null;
        try { nu = await fetchJSON(rootUrl() + 'cart.js'); } catch(e) { break; }
        var rest = (nu && nu.items ? nu.items : []).filter(function(it){ return swIsStaalRegel(it); });
        if (!rest.length) break;
        for (var r = 0; r < rest.length; r++) {
          if (await removeLineByKey(rest[r].key)) { if (!stalenWeg) { stalenWeg++; removed++; } }
          await sleep(80);
        }
      }
    }

    return { removed: removed, checked: checked, stalen: stalenWeg, reason: removed ? 'sanitized' : 'no_changes' };
  }

  // Kevin 15-10-2026: staalregel herkennen (eigen kopie: isSampleLine zit in een andere closure van dit bestand)
  function swIsStaalRegel(item) {
    try {
      var p = (item && item.properties) || {};
      var v = p._is_sample;
      if (v === '1' || v === 1 || v === true || v === 'true') return true;
      var t = [item && item.title, item && item.product_title, item && item.variant_title].join(' ').toLowerCase();
      if (/sample|muster|staal|chantillon|campione|muestra/.test(t)) return true;
      // Kevin 16-10-2026: ook kleurenkaarten, alleen op de variantnaam (Coles' Colour Card is een behang)
      return /kleur(en)?kaart|colou?r ?(card|chart)s?|farbkarte|nuancier|carte de couleurs|cartella colori|carta de colores/i.test(String((item && item.variant_title) || ''));
    } catch(e) { return false; }
  }

  // Kevin 15-10-2026: melding als stalen uit het mandje zijn gehaald (tekst uit snippets/sw-staal-uk.liquid)
  function swStaalUKMelding() {
    var t = window.swStaalUK && window.swStaalUK.weg;
    if (!t) return;
    try {
      var el = document.createElement('div');
      el.setAttribute('role', 'status');
      el.className = 'sw-staal-uk-melding';
      el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;background:#232220;color:#fff;padding:12px 18px;font-size:13px;line-height:1.5;max-width:92vw;box-shadow:0 4px 16px rgba(0,0,0,.2)';
      el.textContent = t;
      document.body.appendChild(el);
      setTimeout(function(){ if (el.parentNode) el.parentNode.removeChild(el); }, 8000);
    } catch(e) {}
  }

  // In het VK ook zonder land- of taalwissel: stalen die nog in het mandje liggen (van vóór 15-10, of via een andere tab)
  function staalUKControle() {
    if (!window.swStaalUK) return;
    fetchJSON(rootUrl() + 'cart.js').then(function(c) {
      if (c && c.items && c.items.some(function(it){ return swIsStaalRegel(it); })) runSync('staal_uk');
    }).catch(function(){});
  }

  var running = false;
  async function runSync(reason) {
    if (running) return;
    running = true;
    try {
      var result = await sanitizeCartForActiveMarket();
      if (result && result.stalen) swStaalUKMelding();
      var cartNow = null;
      try { cartNow = await fetchJSON(rootUrl() + 'cart.js'); } catch(e) {}
      if (cartNow) updateCartCountFromCart(cartNow);
      await refreshDrawerSections();
      if (cartNow) updateCartCountFromCart(cartNow);
      try { document.dispatchEvent(new CustomEvent('swp:market_cart_sanitized', { detail: { reason: reason, result: result }, bubbles: true })); } catch(e) {}
    } catch(e) {
      // Even if sanitize fails, try to refresh the drawer.
      await refreshDrawerSections();
    } finally {
      running = false;
    }
  }

  function markPending() {
    try { localStorage.setItem('swp_market_sync_pending', '1'); } catch(e) {}
  }

  function clearPending() {
    try { localStorage.removeItem('swp_market_sync_pending'); } catch(e) {}
  }

  // Trigger A: native Shopify localization switchers submit to /localization
  document.addEventListener('submit', function(e) {
    try {
      var form = e.target;
      if (form && form.action && String(form.action).indexOf('/localization') !== -1) {
        markPending();
      }
    } catch(err) {}
  }, true);

  document.addEventListener('change', function(e) {
    try {
      var el = e.target;
      if (!el) return;
      var form = el.closest && el.closest('form[action*="/localization"]');
      if (form) markPending();
    } catch(err) {}
  }, true);

  // Run on page load if context changed OR pending flag set (covers redirect-based switchers).
  function boot() {
    staalUKControle();
    var keyNow = ctxKey(CTX);
    var keyPrev = '';
    var pending = false;
    try {
      keyPrev = localStorage.getItem('swp_market_ctx') || '';
      pending = localStorage.getItem('swp_market_sync_pending') === '1';
    } catch(e) {}

    // If this is the first run, store context and do nothing.
    if (!keyPrev) {
      try { localStorage.setItem('swp_market_ctx', keyNow); } catch(e) {}
      if (pending) { clearPending(); }
      return;
    }

    if (pending || keyPrev !== keyNow) {
      clearPending();
      // Update context immediately to prevent loops
      try { localStorage.setItem('swp_market_ctx', keyNow); } catch(e) {}
      runSync(pending ? 'pending_flag' : 'ctx_changed');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
  }
  function boot(){ swCfgAll('levertijd-cart').forEach(function(el){ if (el.__swDone) return; el.__swDone = 1; try { init(swCfgParse(el)); } catch(e){ if (window.console) console.error('levertijd-cart', e); } }); }
  swReady(boot);
  document.addEventListener('shopify:section:load', boot);
})();
